import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { RATES } from "@/lib/constants";

const RatesContext = createContext({ rates: RATES, meta: {}, refresh: () => {} });

export function RatesProvider({ children }) {
  const [rates, setRates] = useState(RATES);
  const [meta, setMeta] = useState({});

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings/rates");
      setRates(data.rates);
      setMeta({ updated_at: data.updated_at, updated_by: data.updated_by });
    } catch {}
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <RatesContext.Provider value={{ rates, meta, refresh }}>{children}</RatesContext.Provider>;
}

export const useRates = () => useContext(RatesContext);
